import MapDraw from 'map/MapDraw';
import { DataPoi, FindPoiOption } from 'map/types/poi';
import { returnAnything } from 'utils/common/returnAnything';

// poi 검색
export const findPoi = (option: FindPoiOption): DataPoi | undefined => {
  return returnAnything<DataPoi>(MapDraw.mapData.dataPoi.find(option));
};
